// The `infra` pack (2026-10-31, alfieOS-plans infra-pack-plan.md phase 1): a
// hundred-foot view of everything the owner runs, Hetzner, home, Oracle and
// object storage, moved out of the dev pack. Read-only for now. No kinds: its
// pages are online-only reads (GET /api/infra, /api/cluster, /api/storage, /api/hosts,
// /api/storage/inventory).
import { Gauge, HardDrive, Server } from 'lucide-react'
import { registerPack } from './index'

export const infraPack = registerPack({
  name: 'infra',
  title: 'Infrastructure',
  description:
    'every estate at a glance (Hetzner, home, Oracle, object storage), its alerts, hosts and storage',
  kinds: [],
  nav: [
    // exact: Overview is not lit on Hosts, which is its own entry
    { to: '/infra', label: 'Overview', icon: '🛰', Icon: Gauge, exact: true },
    { to: '/infra/hosts', label: 'Hosts', icon: '🖥', Icon: Server },
    { to: '/infra/storage', label: 'Storage', icon: '💾', Icon: HardDrive },
  ],
  // its own sidebar section, after Dev; it hides nothing
  layout: { section: 'infra' },
})
